import { property as i } from "./index-Ba2D8NOp.js";
import { r as m } from "./cta-variant-SwPVCQO_-Cf2MRz8Z.js";
import { T as v } from "./tracks-default-slot-BPn9RwTE-DrtwQYQp.js";
import { te as p } from "./abstract-base-DlmRC3qm-BIlD7-mG.js";
import { t as f } from "./beacon-primitive-ChVMWFlW-Df2Js5lw.js";
import { h as g, N as y } from "./query-assigned-DZ4JAxBy-BopcW0Vc.js";
import { C as w } from "./form-associated-L7I3gs1I-BP4RD7d-.js";
import { L as u } from "./reactive-element-BDpydG15-BOs0_4cf.js";
import "./index-BqflxSah.js";
import "./lit-element-DC8UPTKS-4MAMRHpW.js";
import { a as k } from "./lifecycle-decorators-CUsT9aHq-Dtp3uB6c.js";
var h = /* @__PURE__ */ ((t) => (t.LOADING = "loading", t.PROGRESS = "progress", t.SUCCESS = "success", t.RESULT = "result", t.NONE = "", t))(h || {}), d = /* @__PURE__ */ ((t) => (t.SUBMIT = "submit", t.BUTTON = "button", t.RESET = "reset", t.MENU = "menu", t))(d || {});
const S = u`[beacon-tag-name=beacon-button][icon-align=left]{--beacon-button-icon-align: start}.beacon-button-icon{align-self:var(--beacon-button-icon-align, center);block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-5)}.beacon-button-icon .beacon-button-icon--icon{fill:currentcolor}.beacon-button-icon .beacon-button-icon--stroke{stroke:currentcolor}.close-button-wrapper .beacon-button-icon{block-size:unset;inline-size:unset}[beacon-tag-name=beacon-icon-button] .beacon-button-icon{block-size:var(--override-icon-button-block-size, var(--beacon-reference-space-7, calc(1.5 * var(--beacon-unit-base))));inline-size:var(--override-icon-button-inline-size, var(--beacon-reference-space-7, calc(1.5 * var(--beacon-unit-base))))}`, x = u`:host([motion-state=enabled]) a,:host([motion-state=enabled]) button,:host([motion-state=enabled]) .icon-button{--button-base-transition-property: background-color;transition-duration:var(--button-base-transition-duration, 0s);transition-property:var(--button-base-transition-property);transition-timing-function:var(--button-base-transition-timing-function, var(--beacon-system-motion-easing-decelerate-emphasize-1))}:host([motion-state=enabled]) a .contents,:host([motion-state=enabled]) button .contents,:host([motion-state=enabled]) .icon-button .contents{transition-duration:inherit;transition-property:transform;transition-timing-function:inherit}`;
var E = (t, o, n, b) => {
  for (var e = o, s = t.length - 1, c; s >= 0; s--)
    (c = t[s]) && (e = c(e) || e);
  return e;
};
const O = () => function(t) {
  let o = class extends t {
    static get ButtonBaseMotionStyles() {
      return [x];
    }
  };
  return o = E([
    k("ButtonBaseMotion")
  ], o), o;
}, T = u`:is(button,a):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}:is(button,a).tertiary:focus-visible{--second-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--second-ring-width) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus));outline-offset:0;position:relative;z-index:1}`;
var N = Object.defineProperty, r = (t, o, n, b) => {
  for (var e = void 0, s = t.length - 1, c; s >= 0; s--)
    (c = t[s]) && (e = c(o, n, e) || e);
  return e && N(o, n, e), e;
};
const l = {
  icon: "beacon-button-icon",
  strokeFill: "beacon-button-icon--stroke",
  iconFill: "beacon-button-icon--icon"
}, j = "stroke";
class a extends f(w, O(), v({ clean: !0 })) {
  constructor() {
    super(...arguments), this.focusOverride = !0, this.SLOTTED_ICON_INDEX = 0, this.type = d.BUTTON, this.variant = m.PRIMARY, this.state = h.NONE, this.disabled = !1, this.linkHref = "";
  }
  static get styles() {
    return [super.styles, T, this.ButtonBaseMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, S];
  }
  /**
   * Returns the first element in the icon slot
   */
  get icon() {
    return this.iconElements[this.SLOTTED_ICON_INDEX];
  }
  /**
   * Event listener for internal HTML button that
   * determines click behavior depending on its disabled state
   * and button type.
   * @param event click event
   * @event {BeaconEvents} beacon-event-click - Emits when clicked
   */
  handleClick(o) {
    this.disabled ? (o.preventDefault(), o.stopPropagation(), o.stopImmediatePropagation()) : (this.emitClick(o), this.internals && this.type === d.SUBMIT && this.internals.form.requestSubmit());
  }
  /**
   * Applies proper CSS class to slotted SVG such that it renders correctly
   * @param element reference to the slotted SVG
   */
  applySVGClass(o) {
    o && Array.from(o.children).forEach((n) => {
      if (n) {
        const b = n.getAttribute(j) ? l.strokeFill : l.iconFill;
        n.classList.add(b);
      }
    });
  }
  handleIconSlotchange() {
    var o;
    if (this.icon) {
      this.icon.classList.add(l.icon);
      const n = (o = this.label) != null ? o : this.defaultSlotText;
      p(this.icon, n), this.applySVGClass(this.icon);
    }
  }
}
r([
  i({ reflect: !0 })
], a.prototype, "type");
r([
  i({ alternateSlot: "default", sync: !1 })
], a.prototype, "label");
r([
  i()
], a.prototype, "variant");
r([
  i()
], a.prototype, "state");
r([
  i({ type: Boolean })
], a.prototype, "disabled");
r([
  i({ attribute: "link-href" })
], a.prototype, "linkHref");
r([
  i({ attribute: "link-download" })
], a.prototype, "linkDownload");
r([
  i({ attribute: "link-target" })
], a.prototype, "linkTarget");
r([
  g({ flatten: !0, slot: "icon", selector: "svg" })
], a.prototype, "iconElements");
r([
  y("button, a")
], a.prototype, "button");
export {
  a as n
};
